import React, { ReactElement } from 'react';
import { Box, Theme } from '@mui/material';
import { efacityOrgContacts, Footer, type OrganizationInformation } from '@efacity/react-next-sc';
import { defaultOrganizationRegions } from '@efacity/frontend-shared';
import { headerHeight } from '@efacity/common';
import { Header } from '@efacity/frontend-next-shared/header';

const contentSx = (theme: Theme) => ({
  padding: theme.spacing(0, 4),
  flexGrow: 1,
  height: `calc(100% - ${headerHeight}px)`,
  marginLeft: '260px',
  paddingLeft: '15px',
  paddingRight: '15px',
  paddingBottom: '30px',
  overflow: 'scroll',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '30px',
    marginLeft: '26px'
  },
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  })
});

const mainContentSx = (theme: Theme) => ({
  ...contentSx(theme),
  marginLeft: '0px',
  minHeight: `calc(100vh - 120px)`,
  display: 'flex',
  alignContent: 'space-between',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '30px'
  }
});

interface LandingWrapperProps {
  children: any;
  footer?: ReactElement;
  orgInfo?: OrganizationInformation;
}

const efacityOrgInfo = {
  ...defaultOrganizationRegions,
  name: 'Efacity',
  orgId: 'efacity'
} as any as OrganizationInformation;

export const LandingWrapper: React.FC<LandingWrapperProps> = ({
  children,
  footer = <Footer orgInfo={efacityOrgContacts} />,
  orgInfo = efacityOrgInfo
}) => {
  return (
    <div data-testid="home-landing-page">
      <Header orgInfo={orgInfo} />
      <Box sx={mainContentSx}>
        {children}
        {footer}
      </Box>
    </div>
  );
};
